import { render } from "./CrmItemInventory.vue?vue&type=template&id=2d9d93e0"
import script from "./CrmItemInventory.vue?vue&type=script&lang=js"
export * from "./CrmItemInventory.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__